import { createApi } from '@reduxjs/toolkit/query/react';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

import {
  CmsDisclosureRequirementItem,
  CmsDisclosureRequirementResponse,
  GetCmsDisclosureRequirementInput,
  GetCmsDisclosureRequirementsInput,
} from './cmsDisclosureRequirements.types';

interface CmsDisclosureRequirementsResponse {
  disclosureRequirements?: CmsDisclosureRequirementItem[];
}

const cmsDisclosureRequirementsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/cms/standards',
  }),
  reducerPath: 'cmsDisclosureRequirements',
  tagTypes: ['CmsDisclosureRequirements'],
  endpoints: (build) => ({
    getDisclosureRequirements: build.query<
      CmsDisclosureRequirementItem[],
      GetCmsDisclosureRequirementsInput
    >({
      query: ({ standardSlug, slugs }) => ({
        url: `/${standardSlug}/disclosure-requirements`,
        method: 'POST',
        data: { slugs },
      }),
      transformResponse: (response: CmsDisclosureRequirementsResponse) =>
        response.disclosureRequirements ?? [],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          for (const disclosureRequirement of data) {
            dispatch(
              cmsDisclosureRequirementsApi.util.upsertQueryData(
                'getDisclosureRequirement',
                {
                  standardSlug: arg.standardSlug,
                  disclosureRequirementSlug: disclosureRequirement.slug,
                },
                disclosureRequirement,
              ),
            );
          }
        } catch {
          // Ignore cache warmup when list query fails.
        }
      },
    }),
    getDisclosureRequirement: build.query<
      CmsDisclosureRequirementItem,
      GetCmsDisclosureRequirementInput
    >({
      query: ({ standardSlug, disclosureRequirementSlug }) => ({
        url: `/${standardSlug}/disclosure-requirements/${disclosureRequirementSlug}`,
        method: 'GET',
      }),
      transformResponse: (response: CmsDisclosureRequirementResponse) => {
        return response.disclosureRequirement;
      },
    }),
  }),
});

export default cmsDisclosureRequirementsApi;
